@let recordName = recordNameSg();
@let isRecordLoading =
  recordsEc.plugins.currentEntityPlugin.feature.selectors
    .isLoading()
    .asSignal();
@let presentRecordHistoryLog = presentRecordHistoryLogSg();
@let isRecordInCluster = !!clusterSg();
@let isSignedOff = isSignedOffSg();
@let isSigningOff =
  surveyStatusPlugin.selectors.isSubmitting(OperationEnum.SignOff).asSignal();
@let isUnlocking =
  surveyStatusPlugin.selectors.isSubmitting(OperationEnum.Unlock).asSignal();
@let canAssignCluster = !isRecordLoading && !isSignedOff;
@let canSignOff =
  !isRecordLoading &&
  !recordWarningsPlugin.selectors.hasWarnings.asSignal() &&
  !isSigningOff;
@let canUnlock = !isRecordLoading && !isUnlocking;
@let canUnlockRoom = canUnlockSg();

<atn-ds-page [scrollable]="true">
  <div class="atn-record-details">
    <!-- TODO: Provide the `loading` property to show a loader inside the header component when necessary -->
    <atn-ds-page-header
      [breadcrumbs]="breadcrumbsSg()"
      pageHeader
    >
      <div
        name
        class="atn-record-details__title"
      >
        <h4>{{ recordName ? `Room ${recordName}` : recordName }}</h4>
        <atn-ds-tag [text]="surveyStatusSg()" />
      </div>
      <div
        actions
        class="atn-record-details__header-actions"
      >
        <button
          class="atn-record-details__header-action-button"
          [class.atn-record-details__header-action-button--disabled]="
            !canAssignCluster
          "
          [attr.aria-disabled]="!canAssignCluster"
          [atnDsTooltip]="clusterAssignmentTooltipSg()"
          atnDsTooltipPosition="above"
          (click)="canAssignCluster && clusterAssignmentClickHandler()"
        >
          <i class="atn-icon atn-cluster atn-blue"></i>
        </button>
        <button
          #origin
          class="atn-record-details__header-action-button"
          [disabled]="isRecordLoading"
          (click)="presentRecordHistoryLogSg.set(!presentRecordHistoryLog)"
        >
          <i class="atn-icon atn-history atn-blue"></i>
        </button>
        @if (isSignedOff) {
          @if (canUnlockRoom) {
            <button
              class="atn-record-details__header-action-button"
              [disabled]="!canUnlock"
              (click)="initiateClickHandler(OperationEnum.Unlock)"
            >
              <i class="atn-icon atn-unlock atn-blue"></i>
            </button>
          }
        } @else {
          <button
            class="atn-record-details__header-action-button"
            [class.atn-record-details__header-action-button--disabled]="
              !canSignOff
            "
            [attr.aria-disabled]="!canSignOff"
            [atnDsTooltip]="signOffTooltipSg()"
            atnDsTooltipPosition="above"
            (click)="canSignOff && initiateClickHandler(OperationEnum.SignOff)"
          >
            <i class="atn-icon atn-approve atn-blue"></i>
          </button>
        }
      </div>
    </atn-ds-page-header>

    <div class="atn-record-details__content">
      @if (isRecordInCluster) {
        <atn-ds-notice>
          <span description>
            This room belongs to cluster, <b>{{ clusterNameSg() }}</b
            >. Click
            <span
              class="atn-record-details__cluster-notice-link"
              (click)="clusterDetailsClickHandler()"
              >here</span
            >
            to update all of the rooms in the cluster.
          </span>
        </atn-ds-notice>
      }
      <atn-space-record-general [readonly]="isSignedOff" />

      <atn-space-organization-assignments
        [readonly]="isRecordInCluster || isSignedOff"
      />
      <atn-space-functional-usage
        [readonly]="isRecordInCluster || isSignedOff"
      />
      @if (isLabServiceSg()) {
        <atn-space-lab-assignments [readonly]="isSignedOff" />
      }
      <atn-space-occupants
        [collection]="occupantsEc"
        [warningPlugin]="recordWarningsPlugin"
        [readonly]="isRecordInCluster || isSignedOff"
      />
      <atn-space-responsible-persons
        [collection]="responsiblePersonsEc"
        [readonly]="isRecordInCluster || isSignedOff"
      />
    </div>
  </div>
</atn-ds-page>

@if (clusterAssignmentPlugin.selectors.isAssigningCluster.asSignal()) {
  <atn-space-cluster-assignment-modal />
}

@if (presentRecordHistoryLog) {
  <atn-ds-attached-overlay
    [hasBackdrop]="true"
    (backdropClick)="presentRecordHistoryLogSg.set(false)"
    [origin]="origin"
  >
    <atn-record-history-log (close)="presentRecordHistoryLogSg.set(false)" />
  </atn-ds-attached-overlay>
}

@if (
  surveyStatusPlugin.selectors.isConfirming(OperationEnum.SignOff).asSignal()
) {
  <atn-ds-confirmation-overlay
    title="Sign Off Room"
    description="Are you sure want to Sign Off this room?"
    confirmButtonText="Sign Off"
    [loading]="isSigningOff"
    [error]="
      surveyStatusPlugin.selectors
        .getErrorMessage(OperationEnum.SignOff)
        .asSignal()
    "
    (cancel)="cancelClickHandler(OperationEnum.SignOff)"
    (confirm)="confirmClickHandler(OperationEnum.SignOff)"
  />
}

@if (
  surveyStatusPlugin.selectors.isConfirming(OperationEnum.Unlock).asSignal()
) {
  <atn-ds-confirmation-overlay
    title="Unlock Room"
    description="Are you sure?"
    confirmButtonText="Unlock"
    [loading]="isUnlocking"
    [error]="
      surveyStatusPlugin.selectors
        .getErrorMessage(OperationEnum.Unlock)
        .asSignal()
    "
    (cancel)="cancelClickHandler(OperationEnum.Unlock)"
    (confirm)="confirmClickHandler(OperationEnum.Unlock)"
  />
}
